<script>
	import { capitalizeEachWord, slugify } from "cando-util";

	export let file;
	export let showDocPreview = false;
	export let hideIframe = false;
	export let viewed;
	export let updatePartyViewed;

	$: paths = (window?.location?.pathname || "").split("/").filter((e) => !!e);
	$: party = capitalizeEachWord(paths?.[1] || "");

	$: dataUrl = file?.downloadUrl || file?.dataUrl || file?.blob;

	let blobUrl;

	$: (() => {
		if (!(dataUrl || "").startsWith("data:application/pdf")) {
			blobUrl = dataUrl;
			return;
		}
		const base64 = dataUrl.split(",")[1];
		const binary = atob(base64);
		const len = binary.length;
		const bytes = new Uint8Array(len);

		for (let i = 0; i < len; i++) {
			bytes[i] = binary.charCodeAt(i);
		}

		const blob = new Blob([bytes], { type: "application/pdf" });
		blobUrl = URL.createObjectURL(blob);
	})();

	const viewDocument = (event) => {
		// Open the window *first*, immediately
		const win = window.open(blobUrl, "_blank");

		// Only set flags AFTER the window opens
		if (win) {
			const paths = (window?.location?.pathname || "")
				.split("/")
				.filter((e) => !!e);
			if (paths[0] === "sign") {
				const party = capitalizeEachWord(paths[1]);
				viewed[party] = new Date().toISOString();
				updatePartyViewed();
			}
		} else {
			alert("Please allow popups to view the document.");
		}
	};
</script>

<!-- <div>
	{file.downloadUrl}
</div> -->

<div class="w-full">
	<div class="my-2 sm:my-4">
		<div class="flex justify-start gap-4">
			<div>
				<button
					class="btn btn-sm btn-neutral"
					on:click|preventDefault={viewDocument}>View Document</button
				>
			</div>
			<p class="text-xs text-muted my-auto">
				This will open the document in a new tab for your review.
			</p>
		</div>
		{#if party}
			<div>{party} Viewed: {viewed[party] || ""}</div>
		{/if}
	</div>

	{#if !hideIframe}
		<div
			class={`w-full shadow-xl collapse rounded bg-base-100 collapse-arrow`}
		>
			<input
				type="checkbox"
				id={`pdf-collapse-status-for-${slugify(file.name)}`}
				bind:checked={showDocPreview}
			/>
			<!-- <div class="px-2 collapse-title sm:px-4">{file.name} - hash: {file.hash || ''}</div> -->
			<div class="px-2 collapse-title sm:px-4">{file.name}</div>
			<div class="w-full collapse-content grid grid-cols-1 gap-4">
				<div class="">
					{#if (file.type || "").startsWith("image/")}
						<img
							class={`w-full ${!showDocPreview ? "hidden" : ""}`}
							src={blobUrl}
							alt={file?.name || ""}
						/>
						<!-- src={file?.shortUrl || file?.dataUrl} -->
					{:else}
						<iframe
							class={`w-full h-screen ${!showDocPreview ? "hidden" : ""}`}
							title={file?.name}
							src={blobUrl}
						></iframe>
						<!-- src={file?.shortUrl || file?.dataUrl} -->
					{/if}
				</div>
			</div>
		</div>
	{/if}
</div>
